import TooManyRequestsModal from './TooManyRequestsModal.container';

export default TooManyRequestsModal;
